import { defineMessages } from 'react-intl';

export default {
  pages: {
    signup: {
      registration: {
        components: {
          password: defineMessages({
            label: {
              id: 'pages.signup.registration.components.password.label',
              defaultMessage: 'Password:',
            },
            labelShort: {
              id: 'pages.signup.registration.components.password.labelShort',
              defaultMessage: 'Password',
            },
            hint: {
              id: 'pages.signup.registration.components.password.hint',
              defaultMessage: 'Min. 8 characters',
            },
            invalid: {
              id: 'pages.signup.registration.components.password.invalid',
              defaultMessage: 'Password is incorrect. Please, provide min. of 8 characters',
            },
            empty: {
              id: 'pages.signup.registration.components.password.empty',
              defaultMessage: 'Password required',
            },
          }),
        },
      },
    },
  },
};
